import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as FilterIcon } from '../images/filter.svg'
import { ReactComponent as FilterOffIcon } from '../images/filter_off.svg'

import { doChangeFilters } from '../store/actions/channels';
import { selectChannelFilters, selectFilterMenuOpen, selectIsUserGuest, selectLayoutIsStatic } from '../store/selectors';

import styles from './ChannelFilters.module.scss'
import { doSetFilterMenuOpen } from '../store/actions/system';
import classnames from 'classnames';

const ChannelFilters = () => {
  const dispatch = useDispatch();
  const channelFilters = useSelector(selectChannelFilters);
  const hasChannelFilters = Object.keys(channelFilters).length > 0;
  const filterMenuOpen = useSelector(selectFilterMenuOpen);
  const layoutIsStatic = useSelector(selectLayoutIsStatic);
  const userIsGuest = useSelector(selectIsUserGuest);

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const activeFilter = e.currentTarget?.value;

    dispatch(doChangeFilters({
      favorites: activeFilter === 'favorites',
      recent: activeFilter === 'recent'
    }));
  }

  const toggleFilterMenu = () => {
    dispatch(doSetFilterMenuOpen(!filterMenuOpen));
  }

  let filterValue = 'none';
  if (channelFilters.favorites) {
    filterValue = 'favorites';
  } else if(channelFilters.recent) {
    filterValue = 'recent';
  }

  const filterIcon = filterMenuOpen ? <FilterOffIcon /> : <FilterIcon />;

  return (
    <div className={styles.wrapper}>
      { !layoutIsStatic ? <Fragment>
        <button className={classnames(styles.menuButton, {[styles.menuButtonActive]: hasChannelFilters})} onClick={() => toggleFilterMenu()}>{filterIcon}</button>

        <div className={classnames(styles.filterList, {[styles.filterListOpen]: filterMenuOpen})}>
          <h2>Filters</h2>
          <label className={styles.filter}><input type="radio" name="filter" value="none" checked={filterValue === 'none'} onChange={handleFilterChange} /> (None)</label>
          { !userIsGuest && <label className={styles.filter}><input type="radio" name="filter" value="favorites" checked={filterValue === 'favorites'} onChange={handleFilterChange} /> Favorites</label> }
          <label className={styles.filter}><input type="radio" name="filter" value="recent" checked={filterValue === 'recent'} onChange={handleFilterChange} /> Recently Updated</label>
        </div>
      </Fragment> : ""}
    </div>
  )
}

export default ChannelFilters;